export const PollResultText = ({ answer }: { answer: string }) => (
    <span className="inline-block mt-1" data-testid="PollAnswerData">
        {answer}
    </span>
);
